import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import { Button, Modal, Select, Textfield } from "../../../components/core";
import { InputNumber } from "primereact/inputnumber";
import { NumberFormatBase } from "react-number-format";
import { Dialog } from "primereact/dialog";
import { useSelector } from "react-redux";
import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";

import {
	QUERY_Wallet_Operator,
	QUERY_Wallet_Partners,
	QUERY_Wallet_Branches,
	QUERY_Wallet_Agents,
	MUTATION_WALLET_UPDATE,
	NEW_WALLET_MUTATION,
	NEWEST_WALLET_TOP_UP_QUERY,
} from "../../../constants/graphql/drop-off-graphql";

export default function WalletTopUp() {
	const [partnerChoices, setPartnerChoices] = useState([]);
	const [selectedPartner, setselectedPartner] = useState(-1);
	const [selectedPartner2, setselectedPartner2] = useState(-1);
	const [branchChoices, setBranchChoices] = useState([]);
	const [selectedBranch, setSelectedBranch] = useState(-1);
	const [selectedBranch2, setSelectedBranch2] = useState(-1);
	const [agentChoices, setagentChoices] = useState([]);
	const [selectedAgent, setselectedAgent] = useState(-1);
	const [selectedAgent2, setselectedAgent2] = useState(-1);

	const operatorId = JSON.parse(localStorage.getItem("user")).operator_id;
	const fetchOperator = useQuery(QUERY_Wallet_Operator, {
		variables: {
			operatorId: operatorId,
		},
	});

	console.log({ selectedAgent2, selectedBranch2, selectedPartner2 });
	const fetchPartners = useQuery(QUERY_Wallet_Partners, {
		variables: {
			operatorId: operatorId,
		},
	});

	const fetchBranches = useQuery(QUERY_Wallet_Branches, {
		variables: {
			operatorId: operatorId,
		},
	});

	const fetchAgents = useQuery(QUERY_Wallet_Agents, {
		variables: {
			operatorId: operatorId,
		},
	});

	const [fetchAccountBalanceNewest, { data: balance }] = useLazyQuery(
		NEWEST_WALLET_TOP_UP_QUERY
	);

	const [fetchDestinationAccountBalanceNewest, { data: balance2 }] =
		useLazyQuery(NEWEST_WALLET_TOP_UP_QUERY);

	console.log({ balance });

	const selection = [
		{ value: "1", name: "Operator" },
		{ value: "2", name: "Partner" },
		{ value: "3", name: "Branch" },
		{ value: "4", name: "Agent" },
	];

	const selection2 = [
		{ value: "2", name: "Partner" },
		{ value: "3", name: "Branch" },
		{ value: "4", name: "Agent" },
	];

	const selectionFinder = (index) => {
		if (index == 0) {
			if (formData.destination == 1) {
				return selection2;
			}
			// console.log({ selection });
			return selection;
		}
		if (formData.source == 1) {
			return selection2;
		}
		return selection;
	};

	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const [formData, setFormData] = React.useState({
		source: "-1",
		destination: "-1",
		amount: "",
		sourceBalance: "",
		destinationBalance: "",
	});
	const [validation, setValidation] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});
	const [validation2, setValidation2] = React.useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	const handleChange = (event) => {
		const { name, value } = event.target;
		if (name == "source" && value == "1") {
			setFormData((prev) => ({
				...prev,
				sourceBalance: operatorDefaultWalletBalance,
			}));
		}
		if (name == "destination" && value == "1") {
			setFormData((prev) => ({
				...prev,
				destinationBalance: operatorDefaultWalletBalance,
			}));
		}
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const [operatorDefaultWalletBalance, setoperatorDefaultWalletBalance] =
		useState("0");

	const [operatorChoice, setoperatorChoice] = useState([]);
	useEffect(() => {
		if (fetchOperator.data) {
			const tempArr = fetchOperator.data.operators.map((e, i) => {
				const obj = {
					...e,
					value: i,
					name: e.company,
					loadBalance: formData.sourceBalance == 0 ? 0 : formData.sourceBalance,
					destinationBalance:
						formData.destinationBalance == 0 ? 0 : formData.destinationBalance,
				};

				setoperatorDefaultWalletBalance(obj.loadBalance);
				return obj;
			});

			setoperatorChoice(tempArr);
		}
	}, [fetchOperator, formData]);

	console.log({ operatorChoice, fetchOperator, formData });
	console.log({ operatorId });
	// for source
	useEffect(() => {
		const selectedItem = selection.find((x) => x.value === formData.source);

		console.log({ selectedItem });
		if (
			selectedItem &&
			selectedItem.value !== "-1" &&
			operatorId !== -1 &&
			(selectedItem.value === "1" ||
				(selectedItem.value === "2" && selectedPartner !== -1) ||
				(selectedItem.value === "3" && selectedBranch !== -1) ||
				(selectedItem.value === "4" && selectedAgent !== -1))
		) {
			fetchAccountBalanceNewest({
				variables: {
					walletTypeNo: 1,
					accountTypeNo: parseInt(formData.source),
					accountId: getSourceId(),
				},
			});
		}
	}, [
		formData.source,
		selectedPartner,
		selectedBranch,
		selectedAgent,
		operatorId,
	]);

	// for destination
	useEffect(() => {
		const selectedItem = selection.find(
			(x) => x.value === formData.destination
		);

		console.log({ selectedItem });
		if (
			selectedItem &&
			selectedItem.value !== "-1" &&
			operatorId !== -1 &&
			(selectedItem.value === "1" ||
				(selectedItem.value === "2" && selectedPartner2 !== -1) ||
				(selectedItem.value === "3" && selectedBranch2 !== -1) ||
				(selectedItem.value === "4" && selectedAgent2 !== -1))
		) {
			console.log("HELLO");
			fetchDestinationAccountBalanceNewest({
				variables: {
					walletTypeNo: 1,
					accountTypeNo: parseInt(formData.destination),
					accountId: getDistnationId(),
				},
			});
		}
	}, [
		formData.destination,
		operatorId,
		selectedPartner2,
		selectedBranch2,
		selectedAgent2,
	]);

	useEffect(() => {
		if (balance && balance.wallet3) {
			setFormData((prev) => ({
				...prev,
				sourceBalance: balance.wallet3.walletBalance,
			}));
		} else {
			setFormData((prev) => ({
				...prev,
				sourceBalance: 0,
			}));
		}
	}, [balance]);

	useEffect(() => {
		if (balance2 && balance2.wallet3) {
			setFormData((prev) => ({
				...prev,
				destinationBalance: balance2.wallet3.walletBalance,
			}));
		} else {
			setFormData((prev) => ({
				...prev,
				destinationBalance: 0,
			}));
		}
	}, [balance2]);

	console.log({ operatorChoice });

	console.log({ fetchPartners, partnerChoices });

	useEffect(() => {
		if (fetchPartners.data) {
			const tempArr = fetchPartners.data.searchCouriers.map((e, i) => ({
				...e,
				value: i,
				name: e.companyNickname,
				loadBalance: formData.sourceBalance == 0 ? 0 : formData.sourceBalance,
				destinationBalance:
					formData.destinationBalance == 0 ? 0 : formData.destinationBalance,
			}));
			setPartnerChoices(tempArr);
		}
	}, [fetchPartners, formData]);

	console.log({ selectedPartner, selectedPartner2 });

	useEffect(() => {
		if (fetchBranches.data) {
			const tempArr = fetchBranches.data.branches.map((e, i) => ({
				...e,
				value: i,
				name: e.partnerBranch,
				loadBalance: formData.sourceBalance == 0 ? 0 : formData.sourceBalance,
				destinationBalance:
					formData.destinationBalance == 0 ? 0 : formData.destinationBalance,
			}));
			setBranchChoices(tempArr);
		}
	}, [fetchBranches, formData]);

	console.log({ branchChoices });

	useEffect(() => {
		if (fetchAgents.data) {
			const tempArr = fetchAgents.data.agents.map((e, i) => {
				const tempName = e.firstName + " " + e.lastName;
				const agentName = e.agentName || ""; // Assuming agentName is a property of e
				const name =
					agentName === ""
						? tempName === " "
							? "<no name>"
							: tempName
						: agentName;
				return {
					...e,
					value: i,
					name: name,
					loadBalance: formData.sourceBalance == 0 ? 0 : formData.sourceBalance,
					destinationBalance:
						formData.destinationBalance == 0 ? 0 : formData.destinationBalance,
				};
			});
			setagentChoices(tempArr);
		}
	}, [fetchAgents, formData]);

	console.log({ selectedPartner });

	const [MutationWallet] = useMutation(MUTATION_WALLET_UPDATE);
	const [UpdatedWalletMutation] = useMutation(NEW_WALLET_MUTATION);

	console.log({ selectedPartner });
	const getSourceId = () => {
		// if (formData) {
		const selectedItem = selection.find((x) => x.value === formData.source);
		console.log(selectedItem.value);
		if (!selectedItem) return 0;

		switch (selectedItem.value) {
			case "1":
				return operatorId;
			case "2":
				return partnerChoices[selectedPartner]?.partnerId;
			case "3":
				return branchChoices[selectedBranch]?.partnerBranchId;
			case "4":
				return agentChoices[selectedAgent]?.partnerAgentId;
			default:
				return 0;
		}
		// }
	};

	const getDistnationId = () => {
		const selectedItem = selection.find(
			(x) => x.value === formData.destination
		);
		console.log(selectedItem.value);

		switch (selectedItem.value) {
			case "1":
				return operatorId;
			case "2":
				return partnerChoices[selectedPartner2]?.partnerId;
			case "3":
				return branchChoices[selectedBranch2]?.partnerBranchId;
			case "4":
				return agentChoices[selectedAgent2]?.partnerAgentId;
			default:
				return 0;
		}
	};

	const handleSubmit = () => {
		console.log({
			input: {
				accountTypeNoSource: formData.source,
				sourceId: getSourceId(),
				accountTypeNoDestination: formData.destination,
				destinationId: getDistnationId(),
				amount: formData.amount,
			},
		});

		UpdatedWalletMutation({
			variables: {
				amount: formData.amount,
				destinationAccountId: getDistnationId(),
				destinationAccountTypeNo: formData.destination,
				sourceAccountId: getSourceId(),
				sourceAccountTypeNo: formData.source,
				walletTypeNo: 1,
			},
		})
			.then((returndeets) => {
				const returnObject = returndeets.data.transferAmount.success;

				console.log({ returndeets, returnObject });
				setValidation({
					icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
					title: "TOP UP SUCCESSFUL",
					open: true,
					body: (
						<>
							<img
								src={`${process.env.PUBLIC_URL}/assets/images/check.png`}
								alt="modal icon"
								className="mx-auto w-40 h-40"
							/>
							<p className="mb-2">
								Successfully transferred ₱{formData.amount} to{" "}
								<ExampleComponent formData={formData} selection={selection} />.
							</p>
							<p className="font-bold">Top Up Details:</p>
							<p>
								{"Source Wallet: "}
								{selection.find((x) => x.value === formData.source) &&
									selection.find((x) => x.value === formData.source).name}
							</p>
							{/* <p>{`New Balance: ${returnObject.sourceBalance}`}</p> */}
							<p>
								{"Destination Wallet: "}
								{selection.find((x) => x.value === formData.destination) &&
									selection.find((x) => x.value === formData.destination).name}
							</p>
							{/* <p>{`New Balance: ${returnObject.destinationBalance}`}</p> */}
							<Button
								value={"OK"}
								className={"p-2 mt-2 w-full"}
								onClick={() => {
									window.location.reload();
								}}
							/>
						</>
					),
				});
			})
			.catch((e) => {});

		// MutationWallet({
		// 	variables: {
		// 		input: {
		// 			accountTypeNoSource: formData.source,
		// 			sourceId: getSourceId(),
		// 			accountTypeNoDestination: formData.destination,
		// 			destinationId: getDistnationId(),
		// 			amount: formData.amount,
		// 		},
		// 	},
		// })
		// 	.then((returndeets) => {
		// 		const returnObject = returndeets.data.adjustBalance;
		// 		setValidation({
		// 			icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
		// 			title: "TOP UP SUCCESSFUL",
		// 			open: true,
		// 			body: (
		// 				<>
		// 					<img
		// 						src={`${process.env.PUBLIC_URL}/assets/images/check.png`}
		// 						alt="modal icon"
		// 						className="mx-auto w-40 h-40"
		// 					/>
		// 					<p className="mb-2">
		// 						Successfully transferred ₱{formData.amount} to{" "}
		// 						<ExampleComponent formData={formData} selection={selection} />.
		// 					</p>
		// 					<p className="font-bold">Top Up Details:</p>
		// 					<p>
		// 						{"Source Wallet: "}
		// 						{selection.find((x) => x.value === formData.source) &&
		// 							selection.find((x) => x.value === formData.source).name}
		// 					</p>
		// 					<p>{`New Balance: ${returnObject.sourceBalance}`}</p>
		// 					<p>
		// 						{"Destination Wallet: "}
		// 						{selection.find((x) => x.value === formData.destination) &&
		// 							selection.find((x) => x.value === formData.destination).name}
		// 					</p>
		// 					<p>{`New Balance: ${returnObject.destinationBalance}`}</p>
		// 					<Button
		// 						value={"OK"}
		// 						className={"p-2 mt-2 w-full"}
		// 						onClick={() => {
		// 							window.location.reload();
		// 						}}
		// 					/>
		// 				</>
		// 			),
		// 		});
		// 	})
		// 	.catch((e) => {});
	};

	const getDestinationNameWithCase = (formData, selection) => {
		const selectedItem = selection.find(
			(x) => x.value === formData.destination
		);
		if (!selectedItem) {
			return null;
		}

		let caseName = "";
		switch (selectedItem.name) {
			case "Operator":
				caseName = " " + operatorChoice[0].name;
				break;
			case "Agent":
				caseName = " " + agentChoices[selectedAgent2].name;
				break;
			case "Branch":
				caseName = " " + branchChoices[selectedBranch2].name;
				break;
			case "Partner":
				caseName = " " + partnerChoices[selectedPartner2].name;
				break;
			default:
				caseName = "";
		}
		return selectedItem.name + caseName;
	};

	const ExampleComponent = ({ formData, selection }) => {
		const destinationNameWithCase = getDestinationNameWithCase(
			formData,
			selection
		);

		return destinationNameWithCase;
	};

	console.log({ formData, accessPermission });
	return (
		<ContentContainer containerTitle={"Wallet Top Up"}>
			<div className="grid grid-cols-3 gap-2 w-2/3">
				<p className="my-auto">Source: </p>
				<Select
					disabled={
						accessPermission.walletTopUp === 1 ||
						accessPermission.walletTopUp === "1"
					}
					value={formData.source}
					items={selectionFinder(0)}
					onChange={handleChange}
					name="source"
					defaultOption={{ value: "-1", name: "Select a source wallet" }}
				/>
				<div></div>
				<div
					className={`col-span-3 ${
						formData.source == 1 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Operator: </p>
					<Select
						disabled={true}
						value={0}
						items={operatorChoice}
						name="operator"
					/>
					<div className="flex flex-row items-center justify-center">
						{operatorChoice[0] != null && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">₱{operatorChoice[0].loadBalance}</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.source == 2 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Partner: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedPartner}
						items={partnerChoices}
						onChange={(e) => {
							console.log("hey", e);
							setselectedPartner(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									sourceBalance: partnerChoices[e.target.value].loadBalance,
								}));
						}}
						name="partners"
						defaultOption={{ value: -1, name: "Select a partner" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedPartner != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{partnerChoices[selectedPartner].loadBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.source == 3 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Branch: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedBranch}
						items={branchChoices}
						onChange={(e) => {
							setSelectedBranch(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									sourceBalance: branchChoices[e.target.value].loadBalance,
								}));
						}}
						name="branch"
						defaultOption={{ value: -1, name: "Select a branch" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedBranch != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{branchChoices[selectedBranch].loadBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.source == 4 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Branch: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedAgent}
						items={agentChoices}
						onChange={(e) => {
							setselectedAgent(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									sourceBalance: agentChoices[e.target.value].loadBalance,
								}));
						}}
						name="branch"
						defaultOption={{ value: -1, name: "Select agent" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedAgent != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{agentChoices[selectedAgent].loadBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<p className="my-auto">Destination: </p>
				<Select
					disabled={
						accessPermission.walletTopUp === 1 ||
						accessPermission.walletTopUp === "1"
					}
					value={formData.destination}
					items={selectionFinder(1)}
					onChange={handleChange}
					name="destination"
					defaultOption={{ value: "-1", name: "Select a destination wallet" }}
				/>
				<div></div>
				<div
					className={`col-span-3 ${
						formData.destination == 1 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Operator: </p>
					<Select
						disabled={true}
						value={0}
						items={operatorChoice}
						name="operator"
					/>
					<div className="flex flex-row items-center justify-center">
						{operatorChoice[0] != null && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{operatorChoice[0].destinationBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.destination == 2 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Partner: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedPartner2}
						items={partnerChoices}
						onChange={(e) => {
							console.log(e.target.value);
							setselectedPartner2(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									destinationBalance:
										partnerChoices[e.target.value].destinationBalance,
								}));
						}}
						name="partners"
						defaultOption={{ value: -1, name: "Select a partner" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedPartner2 != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{partnerChoices[selectedPartner2].destinationBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.destination == 3 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Branch: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedBranch2}
						items={branchChoices}
						// onChange={(e) => setSelectedBranch2(e.target.value)}
						onChange={(e) => {
							setSelectedBranch2(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									destinationBalance: branchChoices[e.target.value].loadBalance,
								}));
						}}
						name="branch"
						defaultOption={{ value: -1, name: "Select a branch" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedBranch2 != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{branchChoices[selectedBranch2].destinationBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<div
					className={`col-span-3 ${
						formData.destination == 4 ? "" : "hidden"
					} grid grid-cols-3 gap-2 w-full`}
				>
					<p className={`my-auto`}>Agent: </p>
					<Select
						disabled={
							accessPermission.walletTopUp === 1 ||
							accessPermission.walletTopUp === "1"
						}
						value={selectedAgent2}
						items={agentChoices}
						// onChange={(e) => setselectedAgent2(e.target.value)}
						onChange={(e) => {
							setselectedAgent2(e.target.value);
							if (e.target.value != -1)
								setFormData((prev) => ({
									...prev,
									destinationBalance: agentChoices[e.target.value].loadBalance,
								}));
						}}
						name="branch"
						defaultOption={{ value: -1, name: "Select agent" }}
					/>
					<div className="flex flex-row items-center justify-center">
						{selectedAgent2 != -1 && (
							<>
								<p className="mr-4">Wallet Balance: </p>
								<p className="font-bold">
									₱{agentChoices[selectedAgent2].destinationBalance}
								</p>
							</>
						)}
					</div>
				</div>
				<p className="my-auto">
					<b className="text-red-500">*</b> Amount:{" "}
				</p>
				<Textfield
					disabled={
						accessPermission.walletTopUp === 1 ||
						accessPermission.walletTopUp === "1"
					}
					customInput={Textfield}
					value={formData.amount}
					onChange={(e) => {
						const regex = /^\d*\.?\d{0,2}$|^$/;

						if (
							(regex.test(e.target.value) &&
								parseFloat(e.target.value) <= 1000000000) ||
							e.target.value === ""
						) {
							setFormData((prev) => ({ ...prev, amount: e.target.value }));
						}
					}}
				/>
				<div className="grid grid-cols-2 w-1/2 gap-y-2">
					<div></div>
					<u
						className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
						onClick={() => {
							setFormData({
								source: "-1",
								destination: "-1",
								amount: "",
							});
						}}
					>
						<i className="fas fa-undo my-auto"></i>
						<p className="ml-1">Reset</p>
					</u>
				</div>
				<Button
					disabled={
						accessPermission.walletTopUp === 1 ||
						accessPermission.walletTopUp === "1"
					}
					value={"Proceed"}
					className={"p-2"}
					onClick={() => {
						if (
							formData.destination === "-1" ||
							formData.source === "-1" ||
							formData.amount === "" ||
							formData.amount === "0"
						) {
							setValidation2({
								icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
								title: "Incomplete criteria",
								message: `Please input destination, source and amount to top up.`,
								open: true,
								actions: (
									<div className="w-full">
										<Button
											onClick={() => setValidation2({ open: false })}
											value={"OK"}
											className={"p-2 w-full"}
										/>
									</div>
								),
							});
						} else {
							if (
								parseFloat(formData.sourceBalance) < parseFloat(formData.amount)
							) {
								setValidation2({
									icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
									title: "INSUFFICIENT BALANCE",
									message: `The amount you entered is more than the balance of the source wallet.`,
									open: true,
									actions: (
										<div className="w-full">
											<Button
												onClick={() => setValidation2({ open: false })}
												value={"OK"}
												className={"p-2 w-full"}
											/>
										</div>
									),
								});
								return;
							}
							setValidation({
								icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
								title: "CONFIRM TOP UP",
								open: true,
								body: (
									<>
										<img
											src={`${process.env.PUBLIC_URL}/assets/images/warning.png`}
											alt="modal icon"
											className="mx-auto w-40 h-40"
										/>
										<p className="mb-2">
											You are about to transfer ₱{formData.amount} to{" "}
											<ExampleComponent
												formData={formData}
												selection={selection}
											/>
											.
										</p>
										<p>Top Up Details:</p>
										<p>
											Source Wallet:{" "}
											{selection.find((x) => x.value === formData.source) &&
												selection.find((x) => x.value === formData.source).name}
										</p>
										<p>
											{"Current Balance: "}{" "}
											{formData.sourceBalance == null
												? 0
												: formData.sourceBalance}
										</p>
										<p>
											{"Destination Wallet: "}
											{selection.find(
												(x) => x.value === formData.destination
											) &&
												selection.find((x) => x.value === formData.destination)
													.name}
										</p>
										<p>
											{"Current Balance: "}{" "}
											{formData.destinationBalance == null
												? 0
												: formData.destinationBalance}
										</p>

										<div className="grid w-full grid-cols-2 gap-x-2">
											<Button
												value={"Cancel"}
												className={"p-2 mt-2 w-full"}
												onClick={() => {
													setValidation({
														open: false,
													});
												}}
											/>
											<Button
												value={"OK"}
												className={"p-2 mt-2 w-full"}
												onClick={handleSubmit}
											/>
										</div>
									</>
								),
							});
						}
					}}
				/>
			</div>
			<Dialog
				visible={validation.open}
				header={validation.title}
				headerStyle={{ textAlign: "center" }}
				onHide={() => setValidation({ open: false })}
			>
				{validation.body}
			</Dialog>
			<Modal
				icon={validation2.icon}
				title={validation2.title}
				message={validation2.message}
				open={validation2.open}
				actions={validation2.actions}
			/>
		</ContentContainer>
	);
}
